import React from "react";
import NavigateToProductDetail from "src/component/custom/NavigateToProductDetail";
import System from "src/helper/system";

const SearchProducts = (props) => {
    const { translation: t } = System;
    const { productList, getSearchStringBold, searchButtonPressed, searchTerm, isTypeHead } = props

    return (
        <>
            <div className="search-item-title">
                {t('recommendedProducts')}
            </div>
            <div className="search-product-list">
                {Object.keys(productList).length > 0 &&
                    Object.keys(productList).map((p, i) => (
                        <React.Fragment key={p}>
                            {i < 5 && (
                                <div className="search-product-list-item">
                                    <div className="search-product-list-item-info">
                                        <NavigateToProductDetail
                                            data={{ ManufacturerName: productList[p]?.ManufacturerName, ERPMFRPartNumber: productList[p]?.ERPMFRPartNumber, ItemNumber: productList[p]?.ItemNumber, ERPPartNumber: productList[p]?.ERPPartNumber, searchTerm: searchTerm, isTypeHead : true, seoItemNumber: productList[p]?.SEOItemnumber, isTypeHead: isTypeHead }}>
                                            <div className="search-product-list-item-title">{productList[p]?.ERPMFRPartNumber ? productList[p].ERPMFRPartNumber : ""}</div>
                                        </NavigateToProductDetail>
                                        <div className="search-product-list-item-subtitle">
                                            {getSearchStringBold(productList[p].ManufacturerName)}
                                        </div>
                                        <div className="search-product-list-item-desc">
                                            {getSearchStringBold(productList[p].ShortDescription)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
            </div>

            <div className="text-center mt-auto pb-3" style={Object.keys(productList).length === 0 ? { display: "none" } : {}}>
                <a href={void 0} className="bs5 btn btn-sm btn-primary w240"
                    onClick={() => { searchButtonPressed(); }}>
                    {t('viewAllProductsResults')}
                </a>
            </div>
        </>
    )

}

export default SearchProducts